import { useState } from "react";
import { Download, FileUp } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ImportDialog = ({ open, onClose, onDone }) => {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const template = () => window.open(`${process.env.REACT_APP_BACKEND_URL}/api/fabrics/import/template?auth=${localStorage.getItem("token")}`, "_blank");
  const submit = async () => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file); setBusy(true);
    try { const { data } = await api.post("/fabrics/import", fd); setResult(data); toast.success(`${data.created} créé(s), ${data.updated} mis à jour`); onDone?.(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={() => { setResult(null); setFile(null); onClose(); }}>
      <DialogContent data-testid="import-dialog">
        <DialogHeader><DialogTitle className="font-display">Import Excel du catalogue</DialogTitle></DialogHeader>
        <ol className="list-decimal space-y-1 pl-5 text-sm text-muted-foreground">
          <li>Téléchargez le modèle (une colonne « stock:Nom du dépôt » par dépôt).</li>
          <li>Remplissez référence, nom, conditionnement (m / kg / rouleau), prix, seuil, stock de départ.</li>
          <li>Importez : les références existantes sont mises à jour, le stock est ajouté via un bon d'entrée.</li>
        </ol>
        <Button variant="outline" onClick={template} data-testid="import-template-btn"><Download size={16} /> Télécharger le modèle Excel</Button>
        <input type="file" accept=".xlsx" onChange={(e) => setFile(e.target.files[0])} className="text-sm" data-testid="import-file-input" />
        <Button className="bg-[#059669] hover:bg-[#047857]" disabled={!file || busy} onClick={submit} data-testid="import-submit"><FileUp size={16} /> {busy ? "Import en cours…" : "Importer"}</Button>
        {result && <div className="rounded-md bg-muted/60 p-3 text-sm" data-testid="import-result">
          <p><b>{result.created}</b> tissu(s) créé(s), <b>{result.updated}</b> mis à jour{result.stock_documents.length > 0 && <> · bons d'entrée : {result.stock_documents.join(", ")}</>}</p>
          {result.unknown_depots.length > 0 && <p className="text-[#059669]">Dépôts inconnus ignorés : {result.unknown_depots.join(", ")}</p>}
          {result.errors.length > 0 && <ul className="mt-1 list-disc pl-5 text-destructive">{result.errors.map((e, i) => <li key={i}>{e}</li>)}</ul>}
        </div>}
      </DialogContent>
    </Dialog>
  );
};
